<div class="services-list__form" [formGroup]="backwardDeliveryDataGroup">
  <app-custom-return-address *ngIf="customAddresses"
                             [controlName]="returnAddressControlName"
                             [showLabel]="false"
                             [formGroup]="backwardDeliveryDataGroup"
                             [options]="customAddresses"
                             #customAddress
  ></app-custom-return-address>
</div>
